export default __webpack_public_path__ + "static/media/MINUSMA_twitter.236d4d25.png";